import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import { findArea, findWorkflow } from "@/utils/generalFunctions";

export default {
  data() {
    return {
      loadingAllDataRequired: false,
      contract: null,
      inventory: null,
      area: null,
      fatherArea: null,
      workflow: null,
      contractPeople: [],
    };
  },
  computed: {
    ...mapGetters({
      usersFaena: 'usersFaena',
    }),
  },
  async created() {
    this.loadingAllDataRequired = true;
    try {
      this.resetInventory();
      // Obtener Contrato
      await this.getContract(this.$route.params.contratoId);
      // Obtener áreas
      if (this.$store.getters.areas.length === 0) {
        // no hay store de areas
        await this.getContractArea(this.contract.area_id);
        if (this.area && this.area.area_padre_id) {
          await this.getContractFatherArea(this.area.area_padre_id);
        } // if
      } else {
        this.area = findArea(this.contract.area_id);
        this.fatherArea = findArea(this.area.area_padre_id);
      } // if

      // Obtener Workflows
      const cwf = this.contract.workflow;
      if (this.$store.getters.workflows.length === 0) {
        // no hay store de Workflows
        await this.getWorkflowByType(cwf);
      } else {
        this.workflow = findWorkflow(cwf);
      } // if

      // Obtener personas del contrato
      await this.getUsersFaena(this.$store.getters.role.faena_id);
      this.contractPeople = this.usersFaena;
      // Obtener inventario
      await this.getInventory();
      this.loadingAllDataRequired = false;
    } catch {
      this.loadingAllDataRequired = false;
      console.log('Error al cargar los datos');
    }
  },
  methods: {
    ...mapActions([
      'getUsersFaena',
      'resetInventory',
    ]),
    async getContract(id) {
      console.log('Getting Contranct');
      const self = this;
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      };
      await axios.get(`contratos/${id}`, config)
        .then((response) => {
          self.contract = response.data;
          // Para los componentes :/
          self.$store.dispatch('setActualContract', response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getInventory() {
      console.log('Getting Inventory');
      this.loading = true;
      const self = this;
      await this.$store
        .dispatch('getInventory', this.contract)
        .then(() => {
          self.inventory = self.$store.getters.inventario;
          self.loading = false;
        });
    },
    async getContractArea(id) {
      this.area = await this.getArea(id);
    },
    async getContractFatherArea(id) {
      this.fatherArea = await this.getArea(id);
    },
    async getArea(id) {
      console.log('Getting Area');
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
      const response = await axios.get(`areas/${id}`, config);
      return response.data;
    },
    async getWorkflowByType(id) {
      this.workflow = await this.getWorkflow(id);
    },
    async getWorkflow(id) {
      console.log('Getting Workflow');
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
      const response = await axios.get(`workflow/${id}`, config);
      return response.data;
    },
  },
};
